import StyleguideNode from "./styleguideNode";

export default class StyleguideLevel {
    level: number;
    nodes: StyleguideNode[];

    constructor(level: number, nodes: StyleguideNode[] | undefined) {
        this.level = level;
        this.nodes = nodes ?? [];
    }
}
